export const Mydata = {
    data(){
        return{
                // 表头
      column: [
        {
          prop: "is_collect",
          label: "收藏",
          width: "50",
        },
        {
          prop: "system",
          label: "平台",
        },
        {
          prop: "title",
          label: "名称",
        },
        {
          prop: "time",
          label: "时间",
        },
        {
          prop: "activateDevice",
          label: "新激活设备",
        },
        {
          prop: "activateUser",
          label: "活跃用户数",
        },
        {
          prop: "allIncome",
          label: "收入",
          sortable: "custom",
        },
        {
          prop: "orderIncome",
          label: "订单收入",
          sortable: "custom",
        },
        {
          prop: "advertIncome",
          sortable: "custom",
          label: "广告收入",
        },
        {
          prop: "expenditure",
          label: "支出",
          sortable: "custom",
        },
        {
          prop: "proportion",
          label: "ROI",
        },
        {
          prop: "option",
          label: "操作",
        },
      ],  
        }
    }
}